export default __webpack_public_path__ + "static/media/IBMOverflowMenuHorizontalWhite.57b625bd.svg";